import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Row, Col, Card, Form } from 'react-bootstrap';
import AwpIsExpanded from '@components/Common/AwpIsExpanded';
import AwpSpinner from '@components/Common/AwpSpinner';
import { Dropdown } from 'react-bootstrap';
import {
  isJsonValueEmpty,
  isValueEmpty,
  getUtcToLocalByFormat,
  isValidRelElevation,
  isValidRelElevationDigit,
  containsSpecialChars,
} from '@awp/helpers/utilsReact';
import { isValid, setHours, setMinutes, subDays, format as formatDate } from 'date-fns';
import AwpYesNoDialog from '@awp/components/Common/AwpYesNoDialog';
import SegmentInfo from './SegmentInfo';
import SegmentEdit from './SegmentEdit';
import SegmentObservationTypeInfo from './SegmentObservationTypeInfo';
import SegmentObservationTypeEdit from './SegmentObservationTypeEdit';
import SegmentObservationTypeMutiModeEdit from './SegmentObservationTypeMutiModeEdit';
import AwpToastContent from '@components/Common/AwpToastContent';
import { ToastContainer, toast } from 'react-toastify';
import { DeleteJson } from '@awp/helpers/fetchReact';
import {
  isEditing,
  setEditing,
  getCurrentSensorEquipmentPacket,
  getSelectedSegment,
  getOrignSegment,
  getSaveSegmentStatus,
  getSaveSegmentError,
  getDeleteSegmentStatus,
  hasLoaded,
  saveSegment,
  deleteSegment,
  setSegment,
  setOrignSegment,
  setSaveSegmentStatus,
  setSaveSegmentError,
  setDeleteSegmentStatus,
  setDeleteSegmentError,
  setData,
} from '@stores/sensorEquipmentPacketSlice';
import Authorize from '@awp/components/Authorize';
import {
  SENSOR_PLACEMENT_CONFIG,
  FROST_PROBE_CONFIG,
  SNOW_POLE_CONFIG,
  Permissions,
  STATE_STATUS,
} from '@awp/constants';

const txtFontSize = {
  fontSize: '85%',
};
const sotTitleStyle = {
  paddingTop: '0.6rem',
  paddingBottom: '0.6rem',
  display: 'flex',
  alignItems: 'center',
};
const sotOutline = {
  outline: '0.063rem solid black',
  padding: '0rem 1rem',
  outlineOffset: '-0.063rem',
};
const linkButton = {
  display: 'flex',
  alignItems: 'stretch',
  fontSize: '75%',
};
//a blank small column
const blankColumn = {
  maxWidth: '2rem',
};
const btnDelStyle = {
  fontSize: '80%',
};
const Segment = ({ segment }) => {
  const dispatch = useDispatch();
  const inEditing = useSelector(isEditing);
  const currentSensorEquipmentPacket = useSelector(getCurrentSensorEquipmentPacket);
  const selectedSegment = useSelector(getSelectedSegment);
  const selectedOrignSegment = useSelector(getOrignSegment);
  const isLoaded = useSelector(hasLoaded);
  const isSavedSegment = useSelector(getSaveSegmentStatus);
  const isDeletedSegment = useSelector(getDeleteSegmentStatus);
  const saveSegmentError = useSelector(getSaveSegmentError);

  //const [isCollapsed, setIsCollapsed] = useState(true);
  const [showDeleteSegmentConfirm, setShowDeleteSegmentConfirm] = useState(false);
  console.log(segment);
  //isSegCollapsed=0/1 collapsed || 2 expanded
  const setExpanded = (isSegCollapsed = null) => {
    let _segment = { ...segment };
    let _data = { ...currentSensorEquipmentPacket };
    let _sensorEquipmentSets = _data.SensorEquipmentSets;
    let _newSensorEquipmentSets = [];
    _sensorEquipmentSets.map((sp) => {
      let _sp = { ...sp };
      if (_sp.PlacementSegments && _sp.PlacementSegments.length > 0) {
        let _newPlacementSegments = [];
        _sp.PlacementSegments.map((seg) => {
          let _seg = { ...seg };
          if (_seg.Id === _segment.Id) {
            if (isValueEmpty(isSegCollapsed)) {
              _seg.IsSegCollapsed = _segment.IsSegCollapsed === 2 ? 1 : 2;
            } else {
              _seg.IsSegCollapsed = isSegCollapsed;
            }
          }
          _newPlacementSegments.push(_seg);
        });
        _sp.PlacementSegments = _newPlacementSegments;
      }
      _newSensorEquipmentSets.push(_sp);
    });
    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
  };
  const isOtherEditing = () => {
    return !isValueEmpty(inEditing) && inEditing !== SENSOR_PLACEMENT_CONFIG.SEGMENT_TAG + segment.Id;
  };
  const isCurrentEditing = () => {
    return !isValueEmpty(inEditing) && inEditing === SENSOR_PLACEMENT_CONFIG.SEGMENT_TAG + segment.Id;
  };
  const enableEdit = () => {
    if (isOtherEditing() || isCurrentEditing()) return;
    dispatch(setEditing(SENSOR_PLACEMENT_CONFIG.SEGMENT_TAG + segment.Id));
    let _segment = { ...segment };
    if (!isValueEmpty(_segment.SegmentEffectiveTimestamp)) {
      _segment.SegmentEffectiveTimestamp = getUtcToLocalByFormat(
        _segment.SegmentEffectiveTimestamp,
        'yyyy-MM-dd HH:mm',
      );
    }
    if (!isValueEmpty(_segment.SegmentEndTimestamp)) {
      _segment.SegmentEndTimestamp = getUtcToLocalByFormat(_segment.SegmentEndTimestamp, 'yyyy-MM-dd HH:mm');
    }

    dispatch(setOrignSegment(_segment));
    let _segment2 = { ..._segment };
    if (isJsonValueEmpty(segment.SegmentObservationTypes) || segment.SegmentObservationTypes.length === 0) {
      let sotId = SENSOR_PLACEMENT_CONFIG.SOT_ID - 1;
      let newSot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
      newSot.Id = sotId;
      newSot.PlacementSegmentId = SENSOR_PLACEMENT_CONFIG.SEG_ID;
      let newSots = [];
      newSots.push(newSot);
      _segment2.SegmentObservationTypes = newSots;
    }

    dispatch(setSegment(_segment2));
    setExpanded(2);
  };
  const switchViewMode = () => {
    cleanData();
  };
  const cleanData = () => {
    dispatch(setEditing(null));
    dispatch(setOrignSegment(null));
    dispatch(setSegment(null));
    dispatch(setSaveSegmentError(null));
  };
  const handleCancel = () => {
    removeUnsavedNewSegment();
    switchViewMode();
    setSegment({ ...selectedOrignSegment });
  };
  const preErrorCheck = () => {
    let _selectedSegment = { ...selectedSegment };

    //0- check if at least one sot
    if (!_selectedSegment.SegmentObservationTypes || _selectedSegment.SegmentObservationTypes.length === 0) {
      let err = {};
      let v = [];
      v.push('No segment observatio type associated.');
      err['SegmentObservationType.generalerror.' + _selectedSegment.Id] = v;
      toast.error('Could not save placement segment ! No segment observatio type associated.', {
        autoClose: false,
      });
      return err;
    }
    let sotErrs = preSotErrorCheck(_selectedSegment);
    let errs = preSegmentErrorCheck(sotErrs);
    return errs;
  };
  const preSegmentErrorCheck = (sotErrs) => {
    let psErrs = {};
    if (!isJsonValueEmpty(sotErrs)) psErrs = sotErrs;
    //0- check source name
    if (isValueEmpty(selectedSegment.SourceName)) {
      let vals = [];
      vals.push('Source name must be valued.');
      psErrs['PlacementSegment.SourceName.' + selectedSegment.Id] = vals;
    }
    if (containsSpecialChars(selectedSegment.SourceName)) {
      let valsEt01 = [];
      valsEt01.push('Name contains invalid character.');
      psErrs['PlacementSegment.SourceName.' + selectedSegment.Id] = valsEt01;
    }
    // const regEx = /^[0-9a-zA-Z]+$/;
    // if(!isValueEmpty(selectedSegment.SourceName) && !selectedSegment.SourceName.match(regEx)) {
    // 	let vals= [];
    // 	vals.push("Must be alphanumeric characters.");
    // 	psErrs["PlacementSegment.SourceName."+ selectedSegment.Id] = vals;
    // }

    //1- check start date
    if (isValueEmpty(selectedSegment.SegmentEffectiveTimestamp)) {
      let valsEt1 = [];
      valsEt1.push('Date must be valued.');
      psErrs['PlacementSegment.SegmentEffectiveTimestamp.' + selectedSegment.Id] = valsEt1;
    }
    if (!isValid(new Date(selectedSegment.SegmentEffectiveTimestamp))) {
      let valsEt2 = [];
      valsEt2.push('Invalid date.');
      psErrs['PlacementSegment.SegmentEffectiveTimestamp.' + selectedSegment.Id] = valsEt2;
    }
    if (!isValueEmpty(selectedSegment.SegmentEndTimestamp) && !isValid(new Date(selectedSegment.SegmentEndTimestamp))) {
      let valsEt3 = [];
      valsEt3.push('Invalid date.');
      psErrs['PlacementSegment.SegmentEndTimestamp.' + selectedSegment.Id] = valsEt3;
    }

    if (
      !isValueEmpty(selectedSegment.SegmentEndTimestamp) &&
      new Date(selectedSegment.SegmentEffectiveTimestamp) > new Date(selectedSegment.SegmentEndTimestamp)
    ) {
      let valsEt4 = [];
      valsEt4.push('Start date must be before end date.');
      psErrs['PlacementSegment.SegmentEffectiveTimestamp.' + selectedSegment.Id] = valsEt4;
      let valsEt5 = [];
      valsEt5.push('End date must be after start date.');
      psErrs['PlacementSegment.SegmentEndTimestamp.' + selectedSegment.Id] = valsEt5;
    }
    if (isJsonValueEmpty(psErrs)) return null;
    return psErrs;
  };
  const preSotErrorCheck = (_selectedSegment) => {
    let sots = _selectedSegment.SegmentObservationTypes;
    let err = {};
    if (sots && sots.length === 1 && isValueEmpty(sots[0].ObservationTypeId)) {
      let v = [];
      v.push('Observation type is required.');
      err['SegmentObservationType.ObservationTypeId.' + sots[0].Id] = v;
      return err;
    }
    if (sots && sots.length > 1) {
      let emptyOtIds = [];
      let isFoundValued = false;
      sots.map((s, i) => {
        if (isValueEmpty(s.ObservationTypeId)) {
          emptyOtIds.push(s.Id);
        } else {
          isFoundValued = true;
        }
        if (
          SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(_selectedSegment.SensorTypeName) &&
          (s.ObservationTypeName == FROST_PROBE_CONFIG.SUBSFC_TEMP ||
            s.ObservationTypeName == SNOW_POLE_CONFIG.SNWPK_TEMP)
        ) {
          let digits = 1;
          if (!isValidRelElevation(s.RelativeElevationMillimetres)) {
            let v1 = [];
            v1.push('invalid value');
            err['SegmentObservationType.RelativeElevationMillimetres.' + s.Id] = v1;
          } else if (!isValidRelElevationDigit(s.RelativeElevationMillimetres, digits)) {
            let v1 = [];
            v1.push(`Offset can only have ${digits} decimal place`);
            err['SegmentObservationType.RelativeElevationMillimetres.' + s.Id] = v1;
          }
        }
      });
      if (!isFoundValued && emptyOtIds.length > 0) {
        emptyOtIds.map((o, i) => {
          let v = [];
          v.push('Observation type is required.');
          err['SegmentObservationType.ObservationTypeId.' + o] = v;
        });
        return err;
      }
      if (!isJsonValueEmpty(err)) return err;
    }

    //1- check duplicated obervation type id
    let otIds = sots.map((item) => {
      return item.ObservationTypeId;
    });
    let foundErr = false;
    sots.map((s, i) => {
      let dups = [];
      otIds.map((idx) => {
        if (
          s.ObservationTypeId > 0 &&
          s.ObservationTypeId == idx &&
          !(
            _selectedSegment.SensorTypeName === FROST_PROBE_CONFIG.FORST_PROBE_SENSOR_TYPE &&
            s.ObservationTypeName === FROST_PROBE_CONFIG.SUBSFC_TEMP
          ) &&
          !(
            _selectedSegment.SensorTypeName === SNOW_POLE_CONFIG.SNOW_POLE_SENSOR_TYPE &&
            s.ObservationTypeName === SNOW_POLE_CONFIG.SNWPK_TEMP
          )
        )
          dups.push(idx);
      });
      if (dups && dups.length > 1) {
        let v = [];
        v.push('Duplicated observation type selected.');
        err['SegmentObservationType.ObservationTypeId.' + s.Id] = v;
        foundErr = true;
      }
    });
    if (!foundErr) return null;
    return err;
  };

  /// remove empty sot row
  const cleanSegment = () => {
    let _selectedSegment = { ...selectedSegment };
    let _segmentObservationTypes = [..._selectedSegment.SegmentObservationTypes];
    let _cleanSegmentObservationTypes = [];
    _segmentObservationTypes.map((s) => {
      if (!isValueEmpty(s.ObservationTypeId) && s.ObservationTypeId !== 0) _cleanSegmentObservationTypes.push(s);
    });
    _selectedSegment.SegmentObservationTypes = _cleanSegmentObservationTypes;
    return _selectedSegment;
  };

  const removeUnsavedNewSegment = () => {
    let _data = { ...currentSensorEquipmentPacket };
    let _sensorEquipmentSets = [..._data.SensorEquipmentSets];
    let _newSensorEquipmentSets = [];
    let isNew = false;
    _sensorEquipmentSets.map((sp) => {
      let _sp = { ...sp };
      let _newPlacementSegments = [];
      sp.PlacementSegments.map((s) => {
        if (s.Id === SENSOR_PLACEMENT_CONFIG.SEG_ID) {
          isNew = true;
        } else {
          _newPlacementSegments.push(s);
        }
      });
      _sp.PlacementSegments = _newPlacementSegments;
      _newSensorEquipmentSets.push(_sp);
    });
    if (!isNew) return;
    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
  };

  const handleSegmentSubmit = () => {
    dispatch(setSaveSegmentError(null));
    let errs = preErrorCheck();
    if (!isJsonValueEmpty(errs)) {
      dispatch(setSaveSegmentError(errs));
      return;
    }

    let _selectedSegment = cleanSegment();
    if (isValueEmpty(_selectedSegment.SegmentEndTimestamp)) _selectedSegment.SegmentEndTimestamp = null;

    setSaveSegmentStatus(STATE_STATUS.LOADING);
    dispatch(setSegment(_selectedSegment));
    dispatch(saveSegment());
  };

  const deleteSelectedSegment = () => {
    let _selectedSegment = { ...selectedSegment };
    dispatch(setDeleteSegmentError(null));
    setDeleteSegmentStatus(STATE_STATUS.LOADING);
    if (isValueEmpty(_selectedSegment.SegmentEndTimestamp)) _selectedSegment.SegmentEndTimestamp = null;
    dispatch(setSegment(_selectedSegment));
    dispatch(deleteSegment());
  };
  const segmentLocalTime = () => {
    let _segment = { ...segment };
    console.log(_segment);
    if (!isValueEmpty(_segment.SegmentEffectiveTimestamp)) {
      _segment.SegmentEffectiveTimestamp = getUtcToLocalByFormat(
        _segment.SegmentEffectiveTimestamp,
        'yyyy-MM-dd HH:mm',
      );
    }
    if (!isValueEmpty(_segment.SegmentEndTimestamp)) {
      _segment.SegmentEndTimestamp = getUtcToLocalByFormat(_segment.SegmentEndTimestamp, 'yyyy-MM-dd HH:mm');
    }
    return _segment;
  };
  const switchCollapsed = () => {
    // if(selectedSegment && selectedSegment.Id< 0 && isCurrentEditing() && isCollapsed) {
    // 	setIsCollapsed(false);
    // 	return false;
    // }
    return getSegCollapsed();
  };
  const getSegCollapsed = () => {
    return segment.IsSegCollapsed === 2 ? false : true;
  };
  const onClickDeleteSegment = () => {
    setShowDeleteSegmentConfirm(true);
  };
  const isNewSegment = () => {
    let _selectedSegment = { ...selectedSegment };
    if (!_selectedSegment || _selectedSegment.Id < 0) return true;
    return false;
  };
  return (
    segment && (
      <>
        <Row style={{ paddingRight: '0.5rem' }}>
          <Col md={1} style={blankColumn}>
            <AwpIsExpanded collapsed={switchCollapsed()} onClick={() => setExpanded()} />
          </Col>
          {!isCurrentEditing() && segment && <SegmentInfo segment={segment} />}
          {isCurrentEditing() && segment && <SegmentEdit segment={segment} />}
          <Col md={1} style={{ paddingLeft: '0rem' }}>
            {!isCurrentEditing() && (
              <>
                <Authorize requires={[Permissions.WriteSensorPlacement]}>
                  <Button variant="link" style={{ fontSize: '75%' }} onClick={enableEdit} disabled={isOtherEditing()}>
                    {'edit segment'}
                  </Button>
                </Authorize>
              </>
            )}
            {
              <Authorize requires={[Permissions.WriteSensorPlacement]}>
                {isCurrentEditing() && (
                  <div>
                    {isSavedSegment !== STATE_STATUS.LOADING && isDeletedSegment !== STATE_STATUS.LOADING && (
                      <div>
                        {!showDeleteSegmentConfirm && (
                          <div>
                            <Button variant="link" style={{ fontSize: '75%' }} onClick={handleSegmentSubmit}>
                              save
                            </Button>
                            <Button variant="link" style={{ fontSize: '75%' }} onClick={handleCancel}>
                              cancel
                            </Button>
                            <Button
                              variant="danger"
                              style={{
                                fontSize: '70%',
                                padding: '0.12rem',
                                marginLeft: '0.6rem',
                                marginBottom: '0.4rem',
                              }}
                              onClick={onClickDeleteSegment}
                              disabled={isNewSegment()}
                            >
                              Delete
                            </Button>
                          </div>
                        )}
                        {showDeleteSegmentConfirm && (
                          <div style={{ width: '10rem' }}>
                            <AwpYesNoDialog
                              action={deleteSelectedSegment}
                              msg="Delete segment?"
                              setShowYesNoConfirm={setShowDeleteSegmentConfirm}
                              props={{ style: btnDelStyle }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {(isSavedSegment == STATE_STATUS.LOADING || isDeletedSegment == STATE_STATUS.LOADING) && (
                      <AwpSpinner />
                    )}
                  </div>
                )}
              </Authorize>
            }
          </Col>
        </Row>
        {!getSegCollapsed() && (
          <Card.Body style={sotOutline}>
            {segment && SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(segment.SensorTypeName) ? (
              <Row className="bg-primary font-weight-bold text-white" style={{ marginRight: '-1rem' }}>
                <Col style={sotTitleStyle} md={3}>
                  {'Observation Type'}
                </Col>
                <Col style={sotTitleStyle} md={3}>
                  {'Display Name Override'}
                </Col>
                <Col style={sotTitleStyle} md={2}>
                  {'Invalid Data'}
                </Col>
                <Col style={sotTitleStyle} md={2}>
                  {'Relative Elevation ('}&#177;{'cm)'}
                </Col>
                <Col style={sotTitleStyle} md={2}>
                  {'Last Observation'}
                </Col>
              </Row>
            ) : (
              <Row className="bg-primary font-weight-bold text-white" style={{ marginRight: '-1rem' }}>
                <Col style={sotTitleStyle} md={3}>
                  {'Observation Type'}
                </Col>
                <Col style={sotTitleStyle} md={3}>
                  {'Display Name Override'}
                </Col>
                <Col style={sotTitleStyle} md={2}>
                  {'Invalid Data'}
                </Col>
                <Col style={sotTitleStyle} md={4}>
                  {'Last Observation'}
                </Col>
              </Row>
            )}
            {isCurrentEditing() &&
              selectedSegment &&
              selectedSegment.SegmentObservationTypes &&
              selectedSegment.SegmentObservationTypes.length > 0 &&
              selectedSegment.SegmentObservationTypes.map((sot, i) => {
                if (SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(selectedSegment.SensorTypeName)) {
                  return (
                    <div key={'sot_container_key_' + i + ''}>
                      {<SegmentObservationTypeMutiModeEdit key={'sot_edit_key_' + i + ''} sot={sot} />}
                    </div>
                  );
                } else {
                  return (
                    <div key={'sot_container_key_' + i + ''}>
                      {<SegmentObservationTypeEdit key={'sot_edit_key_' + i + ''} sot={sot} />}
                    </div>
                  );
                }
              })}
            {!isCurrentEditing() &&
              segment &&
              segment.SegmentObservationTypes &&
              segment.SegmentObservationTypes.map((sot, i) => {
                return (
                  <div key={'sot_container_key_' + i + ''}>
                    {
                      <SegmentObservationTypeInfo
                        key={'sot_info_key_' + i + ''}
                        sot={sot}
                        isMultiMode={SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(segment.SensorTypeName)}
                      />
                    }
                  </div>
                );
              })}
          </Card.Body>
        )}
      </>
    )
  );
};

Segment.propTypes = {
  segment: PropTypes.any.isRequired,
};

export default Segment;
